import { getPrivacyStatementHtml } from '~/app/utils/get-privacy-statement-html';
import React from 'react';

const PrivacyContainer = () => <div dangerouslySetInnerHTML={{ __html: getPrivacyStatementHtml() }} />;

export default PrivacyContainer;
